import React, { useEffect, useRef, useState } from 'react'
import './downloadinvoice.css'
import { Col, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeftLong, faFileArrowDown } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { toDate } from 'date-fns'
function DownloadInvoice() {
    const [range, setRange] = useState({ from: undefined, to: undefined });
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef();
    const [invcData, setInvoiceData] = useState([])
    const [currentplan, setCurrentPlan] = useState('')
    const [dVal, setDropDown] = useState(0)
    const [showpicker, setShowPicker] = useState(false)
    const [invoice_filter, setInvoiceFilter] = useState('')
    const [from_date, setFromDate] = useState('')
    const [to_date, setToDate] = useState('')
    useEffect(() => {
        switch (dVal) {
            case '0':
                setInvoiceFilter('')
                setShowPicker(false)
                setFromDate('')
                setToDate('')
                setTimeout(() => {
                    fetchInvoiceData()
                }, 1000);
                break;
            case '1':
                setShowPicker(false)
                setInvoiceFilter('last_7_days')
                setFromDate('')
                setToDate('')
                setTimeout(() => {
                    fetchInvoiceData()
                }, 1000);
                break;
            case '2':
                setShowPicker(true)
                setInvoiceFilter('custom_date')
                setTimeout(() => {
                    fetchInvoiceData()
                }, 1000);
                break;
        }
        setInvoiceFilter('')
        setShowPicker(false)
        setFromDate('')
        setToDate('')
        fetchInvoiceData();
    }, [])
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    // Format date or placeholder
    function formatDate(date) {
        if (!date) return '';
        return date.toLocaleDateString('en-CA'); // YYYY-MM-DD format
    }
    const formatLocalDate = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const updateInvoiceList = (value) => {
        setDropDown(value);
        setRange({ from: undefined, to: undefined });
        setInvoiceData([])
        switch (value) {
            case '0':
                setInvoiceFilter('0')
                setShowPicker(false)
                setFromDate('')
                setToDate('')
                break;
            case '1':
                setShowPicker(false)
                setInvoiceFilter('last_7_days')
                setFromDate('')
                setToDate('')
                break;
            case '2':
                setShowPicker(true)
                setInvoiceFilter('custom_date')
                break;
        }
    }
    useEffect(() => {
        if ((invoice_filter === 'last_7_days') || (invoice_filter === 'custom_date' && from_date && to_date)) {
            fetchInvoiceData();
        }
        if ((invoice_filter === '0' || invoice_filter === '')) {
            fetchInvoiceData();
        }
    }, [invoice_filter, from_date, to_date]);
    const fetchInvoiceData = async () => {
        const data = {
            invoice_filter: invoice_filter,
            from_date: from_date,
            to_date: to_date
            /*   from_date:,
              to_date:
   */
        }
        console.log(data);
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/download-invoice`,
            headers: {
                'Authorization': localStorage.getItem('dastaan__token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.request(config).then((response) => {
            setInvoiceData(response?.data?.data);
            setCurrentPlan(response?.data?.current_plan_name);
        })
    }
    const w = window.innerWidth
    return (
        <div className={`main-container ${w > 768 && 'ml-10'}  mt-5`}>
            <Row >
                <Col md={12} xs={12}>
                    <Link to="/my-space">
                        <FontAwesomeIcon className={'text-white'} icon={faArrowLeftLong} />
                        &nbsp;&nbsp;<span className='text-white'>Download Invoice</span>
                    </Link>
                </Col>
                <Col md={12} sm={12}>
                    <div className='outer-body mt-3'>
                        <Row>
                            <Col md={10} xs={6} >
                                <span className='ml-2 inv-heading'>Current Plan</span>
                                <br />
                                <small className='ml-2 inv-sub-heading'>{currentplan}</small>
                            </Col>
                            <Col md={2} xs={6}>
                                <select className='custom-dropdown mt-2' onChange={(e) => { updateInvoiceList(e.target.value); setDropDown(e.target.value) }}>
                                    <option value="0">Current Plan</option>
                                    <option value="1">Last 7 Days</option>
                                    <option value="2">Custom Date</option>
                                </select>
                            </Col>
                            {/* date range */}
                            {
                                showpicker === true && (<>
                                    <Col md={12} xs={12}>
                                        <div ref={ref} style={{ position: 'relative', width: 280 }}>
                                            <input
                                                type="text"
                                                className='daterannge-input'
                                                readOnly
                                                value={
                                                    `${from_date} — ${to_date}`
                                                }
                                                /*  value={
                                                     range?.from && range?.to
                                                         ? `${formatDate(range.from)} — ${formatDate(range.to)}`
                                                         : ''
                                                 } */
                                                onClick={() => setIsOpen(!isOpen)}
                                                style={{ width: '100%', padding: '8px', cursor: 'pointer' }}
                                                placeholder="Select date range"
                                            />
                                            {isOpen && (
                                                <div className='datepicker-main'>
                                                    <DayPicker
                                                        mode="range"
                                                        selected={range}
                                                        /*  onSelect={(newRange) => {
                                                             setRange(newRange);
                                                             // Close only when both dates selected
                                                             if (newRange?.from && newRange?.to) {
                                                                 // Format the dates
                                                                 const fromDate = formatLocalDate(newRange.from);
                                                                 const toDate = formatLocalDate(newRange.to);
                                                                 setFromDate(fromDate)
                                                                 setToDate(toDate)
                                                                 if (fromDate !== ' ' && to_date !== '') {
                                                                     setTimeout(() => {
                                                                         fetchInvoiceData()
                                                                     }, 1000);
                                                                 }
                                                                 // You can also save them in state if needed
                                                                 setIsOpen(false);
                                                             }
                                                         }} */
                                                        onSelect={(newRange) => {
                                                            setRange(newRange);
                                                            if (newRange?.from && newRange?.to) {
                                                                const fromDate = formatLocalDate(newRange.from);
                                                                const toDate = formatLocalDate(newRange.to);
                                                                setFromDate(fromDate);
                                                                if (fromDate !== toDate) {
                                                                    setToDate(toDate);
                                                                    setIsOpen(false);
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </>)
                            }
                        </Row>
                    </div>
                </Col>
                {
                    invcData.length > 0 && (
                        <>
                            <Col md={12} sm={12} className='mt-3'>
                                <span className='inv-heading'>Invoice List</span>
                            </Col>
                        </>
                    )
                }
                {
                    invcData.length === 0 ? (<>
                        <Row className='text-center'>
                            <Col md={12} sm={12} style={{ marginTop: "50%" }}>
                                <Image src={`${process.env.PUBLIC_URL}/images/empty_invoice.svg`} className='invoice_image' />
                            </Col>
                            <Col md={12} sm={12} className='mt-5' style={{ marginBottom: "60%" }}>
                                <span className='text-center invoice-txt'>
                                    No invoice founded for selected date
                                </span>
                            </Col>
                        </Row>
                    </>
                    ) :
                        invcData.map((item, index) => (
                            <>
                                <Col md={12} sm={12} className='mt-2'>
                                    <div className='outer-body'>
                                        <Row>
                                            <Col md={1} sm={1} xs={3} className='text-center'>
                                                <div className='inv-date-sec'>
                                                    <div>
                                                        <span className='date-txt'>{item.only_date}</span>
                                                    </div>
                                                    <div>
                                                        <span className='mnth-yr-txt'>{item.month_year}</span>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={10} sm={10} xs={8}>
                                                <span className='inv-id-txt'>Invoice ID: {item.invoice_number}</span>
                                                <br />
                                                <span className='inv-amnt'>Amt paid : {item.amount}</span>
                                            </Col>
                                            <Col md={1} sm={1} xs={1}>
                                                <div className='download-icon-sec mt-15'>
                                                    <a download={true} href={item.url}>
                                                        <FontAwesomeIcon icon={faFileArrowDown} className='dwnld-icn' />
                                                    </a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </>
                        ))
                }
            </Row>
        </div>
    )
}
export default DownloadInvoice